import React, { useEffect, useState } from 'react';
import axios from '../../axiosConfig';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Logout = () => {
  const navigate = useNavigate();
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const performLogout = async () => {
      try {
        await axios.post('/logout');
        localStorage.removeItem('jwtToken');
        document.cookie = 'jwt=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        if (isMounted) {
          setIsLoggedOut(true);
          toast.success('Logged out successfully');
          navigate('/login'); // Redirect to login page after logout
        }
      } catch (error) {
        toast.error('Error during logout:', error);
        if (isMounted) {
          alert('Error during logout. Please try again.');
        }
      }
    };

    if (!isLoggedOut) {
      performLogout();
    }

    return () => {
      isMounted = false; // Cleanup function to prevent setting state if the component is unmounted
    };
  }, [isLoggedOut, navigate]);

  return (
    <div>
      Logging out...
    </div>
  );
};

export default Logout;
